<div class="modal-header">
    <h2 class="modal-title">{{ "specialOffers.editDateModal.title" | translate }}</h2>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="closeHandler()">
    </button>
</div>

<div class="modal-body">
    <div class="row mb-3">
        <div class="col-md-6 select-date">
            <label class="label-input">
                {{ "specialOffers.editDateModal.fromDate" | translate }}
            </label>
            <kendo-datepicker 
                HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [(ngModel)]="startDate"
                [disabled]="true"
                #startDateInput
                (click)="!startDateInput.isOpen ? startDateInput.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}">
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}">
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
        <div class="col-md-6 select-date">
            <label class="label-input">
                {{ "specialOffers.editDateModal.toDate" | translate }}
            </label>
            <kendo-datepicker HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                name="endDateNgModel"
                #endDateNgModel="ngModel"
                [(ngModel)]="endDate"
                [disabledDates]="disableEndDates"
                #endDateInput
                (click)="!endDateInput.isOpen ? endDateInput.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}">
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}">
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
    </div>
    <div *ngIf="endDateNgModel.dirty"
        HJSuppress 
        class="row d-flex justify-content-center text-danger">
        {{ "specialOffers.editDateModal.confirmationMessage1" | translate }}  
        {{endDate | localizedDate}} 
        {{ "specialOffers.editDateModal.confirmationMessage2" | translate }}
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="closeHandler()">
        {{ "specialOffers.editDateModal.cancel" | translate }}
    </button>
    <button class="btn primary-btn" (click)="changeHandler()">
        {{ "specialOffers.editDateModal.apply" | translate }}
    </button>
</div>
